import axios from 'axios'
import { Dispatch, SetStateAction } from 'react'
import 'regenerator-runtime/runtime'

const messages = {
    erreur: "connexion impossible",
    input:"le user ou le mot de passe est incorrect"
}

class Postier{

    async getToken(request:string,password: string,setToken: Dispatch<SetStateAction<string>>,setUserId, setErrors: Dispatch<SetStateAction<string[]>>, setRole: Dispatch<SetStateAction<string>>){

        axios.post('auth/new',{key:request,password}).then(res=>{
            if(res.data.access_token){
                setToken(res.data.access_token)
                setRole(res.data.role)
                setUserId(res.data.iduser)
                localStorage.setItem("userid",res.data.iduser)
            }else{
                setErrors((errors: string[]) => [...errors, messages.input])
            }
            
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, messages.erreur])
            console.log(err)
        })

    }

    async getRequest(request:string){

        const header = `Authorization: Bearer ${request}`

        console.log({header})

        axios.get('api-v0/protected',{headers:{ Authorization: `Bearer ${request}` }})
            .then(res=>{
            console.log(res)
        })

    }


}

export const postier = new Postier()